import { createRouter, createWebHistory } from "vue-router";
import Dashboard from '@/components/Dashboard'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Profile from '@/components/Profile'
import Notifications from '@/components/Notifications'
import Organizations from '@/components/Organizations'
import LoginRoles from '@/components/LoginRoles'
import Settings from '@/components/Settings'
import SystemText from '@/components/SystemText'
import SuperUserPassword from '@/components/SuperUserPassword'
import FileSpecifications from '@/components/FileSpecifications'
import FileUploads from '@/components/FileUploads'
import FileList from '@/components/FileList'
import Users from '@/components/Users'


const routes =  [
        {
            path: '/',
            name: 'Active Files',
            meta: {
                requiresAuth: true
            },
            component: Dashboard,
            alias: '/Dashboard'
        },
		{
			path: '/dashboard',
			name: 'Active Files',
			meta: {
				requiresAuth: true
			},
			component: Dashboard,
			alias: ['/index.php', '/index.html']
		},
        {
            path: '/favorites',
            name: 'Favorites',
            meta: {
                requiresAuth: true
            },
            component: Dashboard
        },
		{
			path: '/archives',
			name: 'Archived Files',
			meta: {
				requiresAuth: true
			},
			component: Dashboard
		},
		{
			path: '/historical',
			name: 'Historical Files',
			meta: {
				requiresAuth: true
			},
			component: Dashboard
		},
		{
			path: '/login',
			name: 'Login',
			meta: {
				requiresAuth: false
			},
			component: Login,
		},
		{
			path: '/:subdomain/login',
			name: 'Client Login',
			meta: {
				requiresAuth: false
			},
			component: Login
		},
		{
			path: '/profile',
			name: 'Profile',
			meta: {
				requiresAuth: true
			},
			component: Profile
		},
		{
			path: '/forgotpassword',
			name: 'Forgot Password',
			meta: {
				requiresAuth: false
			},
			component: ForgotPassword
		},
		{
			path: '/resetpassword',
			name: 'Reset Password',
			meta: {
				requiresAuth: false
			},
			component: ResetPassword,
			alias: ['/activate']
		},
		{
			path: '/organizations',
			name: 'Clients',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: Organizations
		},
		{
			path: '/users',
			name: 'Users',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: Users
		},
		{
			path: '/loginroles',
			name: 'Login Roles',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: LoginRoles
		},
		{
			path: '/notifications',
			name: 'Notifications',
			meta: {
				requiresAuth: true
			},
			component: Notifications
		},
	    {
		    path: '/logout',
		    name: 'Logout',
		    meta: {
			    requiresAuth: false
		    },
		    component: Logout
	    },
		{
			path: '/helptext',
			name: 'Help Text',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: SystemText
		},
		{
			path: '/systemtext',
			name: 'System Text',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: SystemText
		},
		{
			path: '/settings',
			name: 'Settings',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: Settings
		},
		{
			path: '/superuserpassword',
			name: 'Super User Password',
			meta: {
				requiresAuth: true,
				requiresSecurity: true
			},
			component: SuperUserPassword
		},
		{
			path: '/filespecifications',
			name: 'File Specifications',
			meta: {
				requiresAuth: true,
				requiresSecurity: true,
			},
			component: FileSpecifications
		},
		{
			path: '/fileuploads',
			name: 'File Uploads',
			meta: {
				requiresAuth: true,
				requiresSecurity: true,
			},
			component: FileUploads
		},
		{
			path: '/managefiles',
			name: 'Manage Files',
			meta: {
				requiresAuth: true,
				requiresSecurity: true,
			},
			component: FileList
		},
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
